import React, { useState } from "react";
import PropTypes from "prop-types";
import { AddParticipantButton } from "../../components";
import { usePracticeTeam } from "../../contexts/practice-team-context";
import CreateParticipantForm from "../create-participant-form";

const CreateParticipant = ({ participants }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { loadPracticeTeam } = usePracticeTeam();

  const handleSuccess = () => {
    setIsOpen(false);
    loadPracticeTeam();
  };

  return (
    <React.Fragment>
      {isOpen ? (
        <CreateParticipantForm
          participants={participants}
          onSuccess={handleSuccess}
          onCancel={() => setIsOpen(false)}
        />
      ) : (
        <AddParticipantButton
          onClick={() => setIsOpen(true)}
        />
      )}
    </React.Fragment>
  );
};

CreateParticipant.propTypes = {
  participants: PropTypes.array.isRequired,
};

CreateParticipant.displayName = "CreateParticipant";

export default CreateParticipant;
